var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-button-overlay__container"},[_c('div',{ref:"gradient_container",staticClass:"home-block-overlay__container__gradient",style:(_vm.loadingGradient)},[_c('canvas',{ref:"home_block_gradient",staticClass:"product-button-overlay-canvas"})])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e92f60","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/site/components/bhf-filter/product-button-gradient.vue
// module id = q4bk
// module chunks = 2